/* Progressive enhancement: shopping forms work without JavaScript. */
(() => {
  const bindProducts = (scope = document) => {
    scope.querySelectorAll('[data-product-root]').forEach((root) => {
      const select = root.querySelector('[data-variant-select]');
      if (!select || select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const price = root.querySelector('[data-variant-price]');
        const compare = root.querySelector('[data-compare-price]');
        const unit = root.querySelector('[data-unit-price]');
        const button = root.querySelector('[data-add-button]');
        const sku = root.querySelector('[data-variant-sku]');
        const quantity = root.querySelector('[name="quantity"]');
        if (price) price.textContent = option.dataset.price;
        if (compare) { compare.textContent = option.dataset.compare; compare.hidden = !option.dataset.compare; }
        if (unit) { unit.textContent = option.dataset.unit; unit.hidden = !option.dataset.unit; }
        if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'Sold out' : 'Add to cart'; }
        if (sku) { sku.hidden = !option.dataset.sku; sku.querySelector('span').textContent = option.dataset.sku; }
        if (quantity) {
          quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
          if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
          quantity.value = quantity.min;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
        if (option.dataset.media) {
          const media = Array.from(root.querySelectorAll('.product-media')).find((el) => el.id.endsWith('-' + option.dataset.media));
          if (media) media.scrollIntoView({block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }
      });
    });
  };
  bindProducts();
  document.addEventListener('shopify:section:load', (event) => bindProducts(event.target));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mobile-menu[open], .nav-dropdown[open], .filter[open]').forEach((details) => { details.open = false; details.querySelector('summary')?.focus(); });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.nav-dropdown[open], .filter[open], .mobile-menu[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
})();

/* Fixed-deadline countdowns. Compute from the clock each tick to avoid drift. */
(() => {
  const timers = new Map();
  const targetTimestamp = (root) => {
    const date = (root.dataset.date || '').trim();
    const time = (root.dataset.time || '').trim();
    const offset = (root.dataset.offset || '').trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time) || !/^[+-]\d{2}:[0-5]\d$/.test(offset)) return NaN;
    const [year, month, day] = date.split('-').map(Number);
    const check = new Date(Date.UTC(year, month - 1, day));
    if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) return NaN;
    const [hours, minutes] = offset.slice(1).split(':').map(Number);
    if (hours * 60 + minutes > 14 * 60) return NaN;
    return Date.parse(`${date}T${time}:00${offset}`);
  };
  const stop = (root) => {
    if (timers.has(root)) window.clearInterval(timers.get(root));
    timers.delete(root);
  };
  const bindCountdowns = (scope = document) => {
    scope.querySelectorAll('[data-countdown]').forEach((root) => {
      if (root.dataset.countdownBound) return;
      root.dataset.countdownBound = 'true';
      const digits = root.querySelector('[data-countdown-digits]');
      const status = root.querySelector('[data-countdown-status]');
      const finished = root.querySelector('[data-countdown-finished]');
      const editor = root.dataset.editor === 'true';
      const deadline = targetTimestamp(root);
      if (!Number.isFinite(deadline)) {
        if (!editor) root.hidden = true;
        else {
          digits.hidden = false;
          status.hidden = false;
          status.textContent = !root.dataset.date ? 'Set a target date, time, and UTC offset in this section’s settings.' : 'Check the target date (YYYY-MM-DD), time (HH:MM), and UTC offset (±HH:MM).';
        }
        return;
      }
      status.hidden = true;
      const nodes = ['days', 'hours', 'minutes', 'seconds'].map((key) => root.querySelector(`[data-${key}]`));
      const tick = () => {
        const remaining = deadline - Date.now();
        if (remaining <= 0) {
          digits.hidden = true;
          finished.hidden = false;
          if (root.dataset.hideFinished === 'true' && !editor) root.hidden = true;
          return false;
        }
        finished.hidden = true;
        digits.hidden = false;
        const seconds = Math.ceil(remaining / 1000);
        const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
        values.forEach((value, index) => { nodes[index].textContent = String(value).padStart(2, '0'); });
        return true;
      };
      if (tick()) timers.set(root, window.setInterval(() => {
        if (!root.isConnected || !tick()) stop(root);
      }, 1000));
    });
  };
  bindCountdowns();
  document.addEventListener('shopify:section:load', (event) => bindCountdowns(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-countdown]').forEach(stop);
  });
})();
